import React from "react";
import "./TourPackageSection.css";
import { Link } from "react-router-dom";
import pkg1 from "../../assets/pkg1.png";
import pkg2 from "../../assets/pkg2.png";
import pkg3 from "../../assets/pkg3.png";
import pkg4 from "../../assets/pkg4.png";
import pkg5 from "../../assets/pkg5.png";
import pkg6 from "../../assets/pkg6.png";
import { useNavigate } from "react-router-dom";
const packages = [
  {
    id: 1,
    img: pkg1,
    title: "Indore–Ujjain–Omkareshwar",
    days: "3Days/2Nights",
    price: "6,999/Person",
    extra: "Cab+Hotel+Sightseeing",
    link: "/tour-package-data",
  },
  {
    id: 2,
    img: pkg2,
    title: "Shimla–Manali Tour",
    days: "5Days/4Nights",
    price: "14,999/person",
    link: "/tour-package-data",
  },
  {
    id: 3,
    img: pkg3,
    title: "Delhi–Jaipur",
    days: "3Days/2Nights",
    price: "7,999/Person",
    link: "/tour-package-data",
  },
  {
    id: 4,
    img: pkg4,
    title: "Goa–Beach Holiday",
    days: "4Days/3Nights",
    price: "12,999/Person",
    link: "/tour-package-data",
  },
  {
    id: 5,
    img: pkg5,
    title: "Delhi–Jaipur",
    days: "3Days/2Nights",
    price: "7,999/Person",
    link: "/tour-package-data",
  },
  {
    id: 6,
    img: pkg6,
    title: "Punjab Tour",
    days: "5Days/4Nights",
    price: "14,999/person",
    link: "/tour-package-data",
  },
];

const TourPackageSection = () => {
  const navigate = useNavigate();
  return (
    <div className="packages-section">
      {/* Heading Row */}
      <div className="packages-header">
        <h2>Tour Packages</h2>
        <Link to="/tour-package-view-more">
          {" "}
          <button className="view-more-btn">View More</button>
        </Link>
      </div>

      {/* Grid */}
      <div className="packages-grid">
        {packages.map((item) => (
          <div key={item.id} className="package-card">
            <img src={item.img} alt="" />

            <div className="package-content">
              <h3>{item.title}</h3>
              <p>{item.days}</p>
              <p>{item.price}</p>
              {item.extra && <p>{item.extra}</p>}

              <span
                className="details-btn"
                onClick={() =>
                  navigate(item.link, {
                    state: { title: item.title },
                  })
                }
              >
                View Details
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TourPackageSection;
